import React from "react";
import "./text-input.styles.scss";

const TextInput = ({
  className,
  placeholder,
  label,
  type,
  required,
  maxlength,
  autoFocus,
  ...otherProps
}) => (
  <label className={`text-input w-100 ${required ? "required" : ""}`}>
    {label}
    <input
      className={`trinity-text-input w-100 ${className ? className : ""}`}
      type={type ? type : "text"}
      placeholder={placeholder ? placeholder : ""}
      aria-label="Text input"
      required={required ? true : false}
      maxLength={maxlength}
      {...otherProps}
      autoFocus={autoFocus === true ? true : false}
    />
    {required && <span className="required-text">*</span>}
  </label>
);

export default TextInput;
